String.prototype.beforeLastIndex = function (delimiter) {
    return this.split(delimiter).slice(0,-1).join(delimiter) || this + "";
}

String.prototype.toArgs = function () {
    return this.split(",").map(Number);
}

Array.prototype.addToArgs = function (add) {
    this.push(add);jQuery.unique(this.sort()).sort();return this;
}

Array.prototype.removeFromArgs = function (remove) {
    return $.grep(this, function(value) {
        return value != remove;
    });
}